import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { device } from '../../../utils/helpers'

const FooterLink = styled(Link)`
  text-decoration: none;
  color: #4d4d4d;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const FooterLinkA = styled.a`
  text-decoration: none;
  color: #4d4d4d;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const FooterBottom = styled.div`
  padding: 1.25VW 1.25VW 0 1.25VW;

  @media ${device.tablet} {
    display: flex;
  }
`

const FooterItem = styled.div`
  color: #4d4d4d;
  font-family: 'Barlow';

  @media ${device.tablet} {
    font-size: 9px;
  }

  @media ${device.laptop} {
    font-size: 11px;
  }
`

class Footer extends Component {
  componentDidMount () {
    const script = document.createElement('script')
    script.src = 'https://cdn.iubenda.com/iubenda.js'
    script.async = true
    document.body.appendChild(script)
  }

  render () {
    return (
      <FooterBottom>
        <FooterItem>&copy; NOLEGGIOCAMPI.IT È UN MARCHIO DI AD4 SRLS - &nbsp;</FooterItem>
        <FooterItem> P.IVA 09076750968 - &nbsp;</FooterItem>
        <FooterItem>
          <FooterLinkA href='https://www.iubenda.com/privacy-policy/21238999' className='iubenda-nostyle no-brand iubenda-embed' title='Privacy Policy'>PRIVACY</FooterLinkA> -
          <FooterLinkA href='https://www.iubenda.com/privacy-policy/21238999/cookie-policy' className='iubenda-nostyle no-brand iubenda-embed ' title='Cookie Policy'> COOKIES</FooterLinkA> -
          <FooterLinkA href='https://noleggiocampi.it/condizioni'> CONDIZIONI</FooterLinkA>
        </FooterItem>
      </FooterBottom>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/UI/Footer/CalculatorFooter.js